import React from 'react';
import { CityMap } from './CityMap';
import { ErrorBoundary } from './ErrorBoundary';

export const Theater: React.FC = () => {
  return (
    <div className="w-full h-full relative bg-slate-950">
      <ErrorBoundary>
        <CityMap />
      </ErrorBoundary>
    </div>
  );
};
